
















































import Vue from 'vue';
export default Vue.extend({
    name: 'FinanceVsCard',
    props: {
        flag: {
            default: false,
            required: false,
            type: Boolean,
        },
        title: {
            default: '未命名卡片',
            required: false,
            type: String,
        },
        preValue: {
            default: '0',
            required: false,
        },
        preDesc: {
            default: '没有描述',
            required: false,
            type: String,
        },
        postValue: {
            default: '0',
            required: false,
        },
        postDesc: {
            default: '没有描述',
            required: false,
            type: String,
        },
    },
});
